import { ThemeConfig } from 'antd';

export const theme: ThemeConfig = {
  token: {
    fontFamily: 'Montserrat',
    colorPrimary: '#0041C2',
  },
};
